import { HStack, VStack, Text, Box, useMediaQuery, Pressable, Avatar } from "native-base";
import CryptoJS from "crypto-js";
import { Link } from "react-router-dom";
import { useState } from "react";
import DividerLine from "../../components/divider";
import { COLORS } from "../../utils/colors";
import CommonAvatar from "../../components/avatar";
import {
  companyGroupsSVG,
  eventsImageSVG,
  eventsRatingSVG,
  deleteCardsIconSVG,
} from "../../utils/svg";
import CustomButton from "../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CommonBadge from "../../components/badge";
import { hasPermission, statusMap } from "../../utils/permission";
import config from "../../utils/config";
import { Toaster } from "../../components/toaster";
import CustomModal from "../../components/modal";
import MobileModelSheet from "../../components/actionSheet";
import { LoaderAnimation } from "../../components/spinner";
import { deleteEventDetailsAPI } from "../../api/apis/workflow";

const Events = ({
  events = "",
  eventMonth = "",
  eventDate = "",
  eventName = "",
  images = "",
  ratings = "",
  status = "",
  tabActiveButton = "",
  vendor = false,
  onEventDeleted = null,
  deletedBy = "",
  coordinatorName = "",
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const toaster = Toaster();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteEvent = async () => {
    if (!events?._id) {
      toaster('Event ID not found', 'error', 'error');
      return;
    }

    try {
      setIsDeleting(true);
      LoaderAnimation.show();

      const response = await deleteEventDetailsAPI(events?._id);

      if (response.error) {
        toaster(
          response?.message || 'Failed to delete event',
          'error',
          'error'
        );
      } else {
        toaster(
          response.data?.data?.message || 'Event deleted successfully',
          'success',
          'success'
        );
        closeDeleteModal();

        // Call the callback function to refresh the events list
        if (typeof onEventDeleted === 'function') {
          onEventDeleted();
        }
      }
    } catch (error) {
      console.error('Error deleting event:', error);
      toaster('An error occurred while deleting the event', 'error', 'error');
    } finally {
      setIsDeleting(false);
      LoaderAnimation.hide();
    }
  };

  const getDeleteModalHeader = () => {
    return <>Delete Event</>;
  };

  const getDeleteModalBody = () => {
    return (
      <Box
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Text
          fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        >
          Are you sure you want to delete "{eventName}"?
        </Text>
      </Box>
    );
  };

  const getDeleteModalFooter = () => {
    return (
      <HStack
        justifyContent={'end'}
        width={'100%'}
        space={4}
      >
        <CustomButton
          onPress={closeDeleteModal}
          text='Cancel'
          color={COLORS.MODAL_BACK_BUTTON_COLOR}
          variant='outline'
        />
        <CustomButton
          onPress={handleDeleteEvent}
          text={isDeleting ? 'Deleting...' : 'Delete'}
          color={COLORS.WHITE_COLOR}
          backgroundColor={COLORS.REJECT_TEXT_COLOR}
          isLoading={isDeleting}
        />
      </HStack>
    );
  };

  return (
    <>
      <HStack w="100%" px={8} pb={MobileWindow && 3} pt={MobileWindow ? 3 : 1}>
        <HStack>
          <VStack justifyContent="center" alignItems="center">
            <Text
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              fontSize={MobileWindow ? "11.372px" : "13.518px"}
              color={COLORS.THEME_COLOR}
              lineHeight="0.5rem"
            >
              {eventMonth}
            </Text>
            <Text
              fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
              fontSize={MobileWindow ? "27px" : "28px"}
              color={COLORS.CARD_DATE_COLOR}
            >
              {eventDate}
            </Text>
          </VStack>
          <Box justifyContent={"center"}>
            <DividerLine direction="" />
          </Box>
        </HStack>
        <HStack w="95%" justifyContent="space-between" alignItems="center">
          <Box w={MobileWindow ? "inherit" : "85%"} py={4}>
            <Text
              onPress={() => {
                sessionStorage.setItem(
                  "event",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(events),
                    config.eventKey
                  ).toString()
                );
              }}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              color={COLORS.PARTNERS_HEADING_COLOR}
              pr={MobileWindow && 5}
            >
              {eventName}
            </Text>
            {!MobileWindow && (
              <HStack flex={1} alignItems="center" space={2} py={2}>
                {status === "deleted" ? (
                  <>
                    <Text fontSize="sm">
                      Deleted by : <Text  color={COLORS.GRAY_COLOR} fontSize={'sm'}>{deletedBy}</Text>
                    </Text>
                    <DividerLine />
                    <Text fontSize="sm">
                      Coordinator Name : <Text  color={COLORS.GRAY_COLOR} fontSize={'sm'}>{coordinatorName}</Text>
                    </Text>
                  </>
                ) : !hasPermission("VENDOR") && (
                  <>
                    <CommonAvatar
                      width="30.022px"
                      height="30px"
                      bgcolor={COLORS.PARTNERS_CARD_COLOR}
                      svg={eventsImageSVG}
                    />
                    <Text fontSize="sm">{images} Images</Text>
                    <DividerLine />
                    {eventsRatingSVG}
                    <Text fontSize="sm">{ratings} Star</Text>
                  </>
                )}
                {hasPermission("VENDOR") && (
                  <>
                    <CommonAvatar
                      width="30.022px"
                      height="30px"
                      bgcolor={COLORS.PARTNERS_CARD_COLOR}
                      svg={companyGroupsSVG}
                    />
                    <Text fontSize="sm">{events?.business}</Text>
                  </>
                )}
                {hasPermission("VENDOR") && tabActiveButton === "Current" && (
                  <>
                    <DividerLine />
                    <CommonBadge
                      text={statusMap.indexOf(status) <= 1 ? "New" : "Ongoing"}
                      closebtn={false}
                      colorScheme="#ffd86a"
                    />
                  </>
                )}
              </HStack>
            )}
          </Box>
          {!MobileWindow && status !== "deleted" && (
            <HStack space={3} alignItems="center">
              {((userInfo?.role === 'initiator' && events?.email === userInfo?.email) || userInfo?.role === 'admin') && (
              <Pressable onPress={handleDeleteClick}>
                <Avatar
                  bg={'none'}
                  size={'md'}
                >
                  {deleteCardsIconSVG}
                </Avatar>
              </Pressable>
              )}
              <Link
                style={{ textDecoration: "none" }}
                to={{
                  pathname: `/event-detail`,
                  state: { event_details: events },
                }}
              >
                <CustomButton
                  onPress={() => {
                    sessionStorage.setItem(
                      "event",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(events),
                        config.eventKey
                      ).toString()
                    );
                  }}
                  text="View Detail"
                  bgColor={COLORS.THEME_COLOR}
                  textColor={COLORS.WHITE_COLOR}
                  width="fit-content"
                  py="10px"
                />
              </Link>
            </HStack>
          )}
        </HStack>
      </HStack>
      {MobileWindow && (
        <HStack flex={1} alignItems="center" space={2} px={4} pb={4}>
          {status === "deleted" ? (
            <>
              <Text fontSize="sm">
                Deleted by : <Text color={COLORS.GRAY_COLOR} fontSize={'sm'}>{deletedBy}</Text>
              </Text>
              <DividerLine />
              <Text fontSize="sm">
                Coordinator Name : <Text color={COLORS.GRAY_COLOR} fontSize={'sm'}>{coordinatorName}</Text>
              </Text>
            </>
          ) : !hasPermission("VENDOR") && (
            <>
              <CommonAvatar
                width="30.022px"
                height="30px"
                bgcolor={COLORS.PARTNERS_CARD_COLOR}
                svg={eventsImageSVG}
              />
              <Text fontSize="sm">{images} Images</Text>
              <DividerLine />
              {eventsRatingSVG}
              <Text fontSize="sm">{ratings} Star</Text>
            </>
          )}
          {hasPermission("VENDOR") && (
            <>
              <CommonAvatar
                width="30.022px"
                height="30px"
                bgcolor={COLORS.PARTNERS_CARD_COLOR}
                svg={companyGroupsSVG}
              />
              <Text fontSize="sm">{events?.business}</Text>
            </>
          )}
          {hasPermission("VENDOR") && tabActiveButton === "Current" && (
            <>
              <DividerLine />
              <CommonBadge
                text={statusMap.indexOf(status) <= 1 ? "New" : "Ongoing"}
                closebtn={false}
                colorScheme="#ffd86a"
              />
            </>
          )}
          {((userInfo?.role === 'initiator' && events?.email === userInfo?.email) || userInfo?.role === 'admin') && (
          <Pressable onPress={handleDeleteClick} ml="auto">
            <Avatar
              bg={'none'}
              size={'sm'}
            >
              {deleteCardsIconSVG}
            </Avatar>
          </Pressable>
          )}
        </HStack>
      )}

      {/* Delete Confirmation Modal */}
      {!MobileWindow ? (
        <CustomModal
          size=''
          top={'20px'}
          isOpen={showDeleteModal}
          onClose={closeDeleteModal}
          header={getDeleteModalHeader()}
          body={getDeleteModalBody()}
          footer={getDeleteModalFooter()}
          width='fit-content'
          height='fit-content'
          fixedPosition={true}
          fixedTop={180}
        />
      ) : (
        <MobileModelSheet
          isOpen={showDeleteModal}
          onClose={closeDeleteModal}
          header={getDeleteModalHeader()}
          body={getDeleteModalBody()}
          footer={getDeleteModalFooter()}
          maxH={'80vh'}
          position='hidden'
        />
      )}
    </>
  );
};

export default Events;
